import request from '@/plugins/axios'
import { deserializeObject } from "@/util/nativeHelper";

export function savePlayer(player){
  const availableKey = ['name','color','meta','kakao_id','mileage']
  const instance = {...player}
  const playerId = player.player_id
  const isNew = `${playerId}`.match(/new/gi)
  instance.meta = JSON.stringify(instance.meta)
  let query = ''
  if(isNew){
    const insertColumns = availableKey.filter(key => instance[key])
    query = `
    INSERT INTO player (
        ${insertColumns.join(',')}
    ) VALUES (
        ${insertColumns.map(
            key => `'${instance[key]}'`
        ).join(',')}      
   )
`
  }else{
    const update = Object.entries(instance)
    .filter(([key,value])=> (value || value === 0) && availableKey.includes(key))
    .map(([key,value])=> `${key} = '${value}'`)
    query = `UPDATE player
  SET
      ${update.join(',')},
      player_id = player_id
  WHERE player_id = ${playerId}
  `
  }

  return request.post('/dbManager?updatePlayer',{query})
}

export function getPlayers(){
  const query = 'SELECT * FROM player WHERE hidden = 0'
  return request.post('/dbManager?getPlayers',{query}).then(({data})=>{
    return data.result.map(deserializeObject)
  })
}

export function getPlayerByPlayerId(playerId){
  const query = `SELECT * FROM player WHERE player_id='${playerId}'`
  return request.post('/dbManager?getPlayerByPid',{query}).then(({data})=>{
    return data.result.map(deserializeObject)[0]
  })
}

export function getPlayerByKakaoId(kakaoId){
  const query = `SELECT * FROM player WHERE kakao_id='${kakaoId}'`
  return request.post('/dbManager?getPlayerByKakao',{query}).then(({data})=>{
    return data.result.map(deserializeObject)[0]
  })
}
